module.exports = __webpack_public_path__ + "static/1-b69d56a9d4a4271124a363eca729cc75.jpg";